import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
import { jsonGet } from '@square/dashboard-utilities/utils/xhr';
import { apiHost } from '@square/environment-utils/api-urls';
export function multipassStatusURL() {
  const {
    protocol
  } = location;
  // Multipass service endpoints are on api.squareup*
  const host = apiHost(location.host);
  if (host === location.host) {
    return '/mp/status';
  } else {
    return `${protocol}//${host}/mp/status`;
  }
}
export const multipassStatusMocks = {
  getMultipassStatus() {
    return jsonGet(multipassStatusURL());
  }
};
export function getMultipassStatus() {
  return multipassStatusMocks.getMultipassStatus();
}
export function updateCsrfToken() {
  return getMultipassStatus().then(function () {
    const csrfToken = getCsrfToken();
    document.querySelector('meta[name=csrf-token]')?.setAttribute?.('content', csrfToken);
  });
}
export function isLoggedIn() {
  return fetch(`${window.location.origin}/mp/status`).then(response => response.status === 200);
}